import { Plus } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { PhonePrimary } from '@/admin-area/ui/PhonePrimary';
import { Button } from '@/components/ui/button';

/**
 * «+ Nuova spesa» at the bottom of the phone's expense pages (the list and an expense's detail),
 * above the tab bar and within reach of the thumb. «Nuova spesa» is an action, not a place: it has
 * no entry of its own in the menu or in the phone's tabs. Wider screens show the head's button.
 */
export function NewExpensePhonePrimary() {
  const { t } = useTranslation('expenses');
  return (
    <PhonePrimary>
      <Button asChild>
        <Link to="/expenses/new">
          <Plus />
          {t('list.new')}
        </Link>
      </Button>
    </PhonePrimary>
  );
}
